import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import SubjectsSetup from "Administrator/routes/AcademicSetup/routes/SubjectsSetup";
import Atls from "Administrator/commonComponents/Atls";
import SubjectStandardsV2 from "Administrator/commonComponents/SubjectStandardsV2";
import WorkbookTemplates from "Administrator/commonComponents/WorkbookTemplates";
import StudentProfileTemplates from "Administrator/commonComponents/StudentProfileTemplates";
import PlannerElementSetConfiguration from "Administrator/commonComponents/PlannerElementSetConfiguration";
import FieldsConfiguration from "Administrator/commonComponents/FieldsConfiguration";
import ManageTemplates from "Administrator/commonComponents/ManageTemplates";

import { injectReducer } from "store/reducers";
import GradingPeriods from "Administrator/commonComponents/GradingPeriods";
import GradingPeriodsV3 from "Administrator/commonComponents/GradingPeriodsV3";
import {
  GradingSetupRoute,
  GradingSetupRouteV2,
  EvaluationCriteriaRoute,
  GPAAndCreditsRoute,
  RoutineAndMealTemplatesRoute,
  AssessmentToolRoute,
  ProgressReportsRoute,
  Departments,
  SubjectsSetupV2,
} from "./routes";

export default store => ({
  path: "academic/:academicId",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
        import(
          /* webpackChunkName: "admin-academicSetup" */ "Administrator/routes/AcademicSetup/modules/AcademicSetupModule"
        ),
        import(
          /* webpackChunkName: "administrator" */ "Administrator/modules/AdministratorModule"
        ),
      ]).then(([importedModule0, importedModule1, importedModule2]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        const administratorModule = importedModule2.default;
        injectReducer(store, {
          key: "administrator",
          reducer: administratorModule,
        });
        injectReducer(store, {
          key: "academicSetup",
          reducer,
        });

        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    SubjectsSetup(store),
    GradingPeriods(store),
    GradingPeriodsV3(store),
    GradingSetupRoute(store),
    GradingSetupRouteV2(store),
    EvaluationCriteriaRoute(store),
    GPAAndCreditsRoute(store),
    WorkbookTemplates(store),
    AssessmentToolRoute(store),
    StudentProfileTemplates(store),
    PlannerElementSetConfiguration(store),
    FieldsConfiguration(store),
    ManageTemplates(store),
    RoutineAndMealTemplatesRoute(store),
    Atls(store),
    SubjectStandardsV2(store),
    ProgressReportsRoute(store),
    SubjectsSetupV2(store),
    Departments(store),
  ],
});
